export default {"src":"/_next/static/media/ai-menu-icon.5e939d35.svg","height":14,"width":14};